import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  LoadingEvent,
  useDataProvider,
  useSnackbar,
} from '@ui-framework/index';
import { FormattedMessage } from 'react-intl';
import { CUTOFF_TIME_MAX_DAYS_BEFORE } from '@constants';
import lib from '../../../utils/lib';

function CutOffDay({ value = '', onChange, dayOfWeek }) {
  const snackbar = useSnackbar();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get, getApiUrl } = useDataProvider(provider);
  const [cutOffDayOffsets, setCutOffDayOffsets] = useState([]);
  const [loading, setLoading] = useState(true);

  const params = {
    snackbar,
    get,
    getApiUrl,
  };

  const initialize = async () => {
    setLoading(true);
    const response = await lib.fetchCutOffDayOptions({
      maxDaysBefore: CUTOFF_TIME_MAX_DAYS_BEFORE,
      params,
      dayOfWeek,
    });
    if (response?.data) {
      setCutOffDayOffsets(response?.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    initialize();
  }, [dayOfWeek]);

  if (loading) {
    return (
      <LoadingEvent>
        <FormattedMessage id="LOADING" defaultMessage="Loading" />
        ...
      </LoadingEvent>
    );
  }

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="cutoff-day-label">
        <FormattedMessage id="CUTOFF_DAY" defaultMessage="Cutoff Day" />
      </InputLabel>
      <Select value={value} onChange={onChange}>
        {cutOffDayOffsets.map(off => (
          <MenuItem key={off?.label} value={off?.cutoffDayOffset}>
            {off?.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default CutOffDay;
